<template>
  <v-select
    :value="value"
    :label="label"
    :items="items"
    @input="onInput"
  ></v-select>
</template>

<script>
const abc = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export default {
  $_veeValidate: {
    name() {
      return this.label;
    }
  },
  inject: {
    $validator: "$validator"
  },
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      required: true
    },
    numberOfColumns: {
      type: Number,
      default: 0
    }
  },
  computed: {
    items() {
      const letters = abc.substring(0, this.numberOfColumns).split("");
      //first letter A is 1 for safer validation
      return letters.map((letter, index) => {
        return {
          value: index + 1,
          text: letter
        };
      });
    }
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
    }
  }
};
</script>
